import { Form } from 'formik';
import styled from 'styled-components';
import tw from 'twin.macro';

import { Text } from '@/atoms/Text/Text';

export const AuthForm = styled(Form)`
  ${tw`flex flex-col items-stretch flex-1 flex-grow w-full`}
  isolation: isolate;
`;

export const FormFooter = styled.div`
  ${tw`flex flex-col items-stretch text-center space-y-6 md:space-y-8 `}
`;

export const InputsWrapper = styled.div`
  ${tw`flex flex-col flex-1 flex-grow space-y-2 mb-2 sm:mb-4`}
  & [data-needl-input] {
    ${tw`border-gray-500 text-gray-900 py-2.5`}
  }
`;

export const FooterWrapper = styled.div`
  ${tw`max-w-lg z-10 sm:pb-0 mt-2 sm:mt-8`}
`;

export const Container = styled.div`
  ${tw`h-mobile-safe-area lg:h-full flex flex-col`}
`;

export const Row = styled.div`
  ${tw`flex flex-1 flex-col lg:flex-row`}
`;

export const Column = styled.div`
  ${tw`flex-1 lg:w-1/2 px-4 sm:px-12 lg:px-0 flex flex-col justify-center items-center`}
`;

export const StyledText = styled(Text)`
  ${tw`text-gray-500`}
`;
